import { FC, useMemo } from 'react'
import { Button, FormInput, useModal } from '../../../../../../components'
import { ButtonType, ID, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { registerPendencia, resolvePendencia } from '../../../../atendimento/core/_requests'
import { useFormik } from 'formik'
import { anotacaoSchema } from './validation/anotacaoSchema'
import { useT } from '_metronic/i18n/Metronici18n'
import { useLocation, useNavigate } from 'react-router-dom'

interface IAnotacaoModal {
  isPendente?: boolean
  atendimentoId: ID
}

export const AnotacaoModal: FC<IAnotacaoModal> = ({ atendimentoId, isPendente }) => {
  const { closeModal } = useModal()
  const { t } = useT()
  const navigate = useNavigate()
  const location = useLocation()

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { anotacao: '' },
    validationSchema: useMemo(() => anotacaoSchema(t), [t]),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        isPendente
          ? await resolvePendencia(values.anotacao, atendimentoId)
          : await registerPendencia(values.anotacao, atendimentoId)
        await showAlert({
          title: isPendente ? 'Resolvido' : 'Pendência Adicionada',
          text: isPendente
            ? 'Pendência resolvida com sucesso!'
            : 'Pendência adicionada com sucesso!',
          icon: 'success',
        })
        const path = '/apps/atendimentosMedicos/lista'
        closeModal()
        if (!isPendente && location.pathname !== path) navigate(path)
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormInput formik={formik} entity='observacao' name='anotacao' isRequired />
      <div className='d-flex justify-content-center pt-5'>
        <Button className='btn-secondary me-2' onClick={closeModal}>
          {t('common.cancel')}
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary'>
          {t('common.save')}
        </Button>
      </div>
    </form>
  )
}
